import { getString } from 'firebase/remote-config'
import $http from '../../utils/http'
import { getLocale } from '../../i18n/index'

// Сколько максимум ждём первую активацию Remote Config перед чтением ключа:
// дольше - читаем как есть (пусто/кэш SDK), чтобы виджеты не висели на медленной сети
const ACTIVATION_WAIT_LIMIT = 10000

const tools = {
  namespaced: true,

  state: {
    firebaseApp: null,
    firebaseRemoteConfig: null,
    firebaseRemoteConfigReady: null,
    cashRegisterSwitch: false,
    snackbar: '',
    keyListenerEnabled: true,
    appInitialized: false,
    connectionWarning: false,
    cordovaBuildVersion: null,
    ticketLocale: getLocale(),
    unreadMessagesCount: 0,
    helpCrunchUnreadCount: 0,
    currentFlashBanner: null,
    globalLoading: false,
    appUpdateWarningShown: false,
  },

  mutations: {
    set(state, { type, value }) {
      state[type] = value
    },
  },

  actions: {
    // Firebase stuff
    setFirebaseApp({ commit }, payload) {
      commit('set', { type: 'firebaseApp', value: payload })
    },

    setFirebaseRemoteConfig({ commit }, payload) {
      commit('set', { type: 'firebaseRemoteConfig', value: payload })
    },

    setFirebaseRemoteConfigReady({ commit }, payload) {
      commit('set', { type: 'firebaseRemoteConfigReady', value: payload })
    },

    async firebaseRemoteConfigGetString({ state }, payload) {
      // Свежая установка: до первой активации все ключи - пустые строки.
      // Ждём fetchAndActivate (см. initRemoteConfig в main.js), но не дольше лимита
      if (state.firebaseRemoteConfigReady) {
        await Promise.race([
          state.firebaseRemoteConfigReady,
          new Promise((resolve) => { setTimeout(resolve, ACTIVATION_WAIT_LIMIT) }),
        ])
      }
      if (window.cordova) {
        return new Promise((resolve) => {
          window.FirebasePlugin.getValue(payload, (value) => {
            resolve(value)
          }, () => {
            resolve('')
          })
        })
      }
      return getString(state.firebaseRemoteConfig, payload)
    },

    // Other stuff
    showCashRegisterSwitch({ commit }, payload) {
      commit('set', { type: 'cashRegisterSwitch', value: payload })
    },

    showSnackbar({ commit }, payload) {
      commit('set', { type: 'snackbar', value: payload })
    },

    setKeyListenerStatus({ commit }, payload) {
      commit('set', { type: 'keyListenerEnabled', value: payload })
    },

    setAppInitialized({ commit }, payload) {
      commit('set', { type: 'appInitialized', value: payload })
    },

    setTicketLocale({ commit }, payload) {
      commit('set', { type: 'ticketLocale', value: payload })
    },

    setConnectionWarning({ commit }, payload) {
      commit('set', { type: 'connectionWarning', value: payload })
    },

    setCordovaBuildVersion({ commit }, payload) {
      commit('set', { type: 'cordovaBuildVersion', value: payload })
    },

    setHelpCrunchUnreadCount({ commit }, count) {
      commit('set', { type: 'helpCrunchUnreadCount', value: count })
    },

    copyToClipboard({}, payload) {
      const el = document.createElement('textarea')
      el.addEventListener('focusin', e => e.stopPropagation())
      el.value = payload
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false
      el.select()
      document.execCommand('copy')
      // document.body.removeChild(el) // Remove the <textarea> element
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
    },

    uploadImage({ }, payload) {
      return $http.post('/logo/api/upload', payload.data)
    },

    uploadSheetson({ }, payload) {
      return $http.post('/sheetson/api/upload', payload.data)
    },

    fetchUnreadMessagesCount({ commit }) {
      $http.get('/notification/messages/unread-count').then((response) => {
        commit('set', { type: 'unreadMessagesCount', value: response.data })
      }).catch((error) => {
        console.error('Error fetching unread messages count:', error)
      })
    },

    setCurrentFlashBanner({ commit }, payload) {
      commit('set', { type: 'currentFlashBanner', value: payload })
    },

    setGlobalLoading({ commit }, payload) {
      commit('set', { type: 'globalLoading', value: payload })
    },

    setAppUpdateWarningShown({ commit }, payload) {
      commit('set', { type: 'appUpdateWarningShown', value: payload })
    },
  },
}

export default tools
